import { render, staticRenderFns } from "./RestaurantPhoneNumber.vue?vue&type=template&id=2819880e&scoped=true&"
import script from "./RestaurantPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./RestaurantPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantPhoneNumber.vue?vue&type=style&index=0&id=2819880e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819880e",
  null
  
)

export default component.exports